import { BarDataItem, Resolution } from 'api/v1/market'

export const BarArrayToObject = (arr: BarDataItem[]) => {
  const res: any[] = []
  Array.from(arr)?.forEach((item) => {
    res.push({
      time: item[0],
      open: item[1],
      high: item[2],
      low: item[3],
      close: item[4],
      volume: item[5],
    })
  })
  return res
}
export const getBarType = (resolution: string): Resolution => {
  let type: Resolution = 'MIN15'

  switch (resolution) {
    case '1':
      type = 'MIN'
      break
    case '5':
      type = 'MIN5'
      break
    case '15':
      type = 'MIN15'
      break
    case '30':
      type = 'MIN30'
      break
    case '60':
      type = 'HOUR'
      break
    case '240':
      type = 'HOUR4'
      break
    case '1D':
      type = 'DAY'
      break
    case '1W':
      type = 'WEEK'
      break
    case '1M':
      type = 'MONTH'
      break
  }

  return type
}
